<page-heading [title]="'channel.view.pageTitle' | translate: { name: $safeNavigationMigration(channel?.name) }"
  [description]="'channel.view.pageDescription' | translate: { type: getTranslatedTypeChannel($safeNavigationMigration(channel?.type)) }" />

@if (channel) {
<ul class="nav nav-tabs nav-bordered mb-3">
  <li class="nav-item">
    <a class="nav-link active" id="dash-tab" data-bs-toggle="tab" data-bs-target="#dash" type="button" role="tab"
      aria-controls="dash" aria-selected="true" (click)="activate('dash')">
      <i class="mdi mdi-account-circle d-md-none d-block"></i>
      <span class="d-none d-md-block">Dashboard</span>
    </a>
  </li>
  <!-- RCS is conversational-only now, so it gets the full tab set like any other attendance channel. -->
  @if (channel?.type !== 'VOIP_API') {
  @if (channel?.type !== 'WEBCHAT_API') {
  <li class="nav-item">
    <a class="nav-link" id="config-tab" data-bs-toggle="tab" data-bs-target="#config" type="button" role="tab"
      aria-controls="config" aria-selected="true" (click)="activate('config')">
      <i class="mdi mdi-account-circle d-md-none d-block"></i>
      <span class="d-none d-md-block">{{ 'channel.view.tabSettings' | translate }}</span>
    </a>
  </li>
  }
  <li class="nav-item">
    <a class="nav-link" id="auto-tab" data-bs-toggle="tab" data-bs-target="#auto" type="button" role="tab"
      aria-controls="auto" aria-selected="true" (click)="activate('auto')">
      <i class="mdi mdi-account-circle d-md-none d-block"></i>
      <span class="d-none d-md-block">{{ 'channel.view.tabAutoAttendance' | translate }}</span>
    </a>
  </li>
  <li class="nav-item">
    <a class="nav-link" id="response-tab" data-bs-toggle="tab" data-bs-target="#response" type="button" role="tab"
      aria-controls="response" aria-selected="true" (click)="activate('response')">
      <i class="mdi mdi-account-circle d-md-none d-block"></i>
      <span class="d-none d-md-block">{{ 'channel.view.tabAutoResponses' | translate }}</span>
    </a>
  </li>
  @if (channel?.type === 'CLOUD_API') {
  <li class="nav-item">
    <a class="nav-link" id="template-tab" data-bs-toggle="tab" data-bs-target="#template" type="button" role="tab"
      aria-controls="template" aria-selected="true" (click)="activate('template')">
      <i class="mdi mdi-account-circle d-md-none d-block"></i>
      <span class="d-none d-md-block">Templates</span>
    </a>
  </li>
  }
  @if (channel?.type !== 'WEBCHAT_API') {
  <li class="nav-item">
    <a class="nav-link" id="mod-tab" data-bs-toggle="tab" data-bs-target="#mod" type="button" role="tab"
      aria-controls="mod" aria-selected="true" (click)="activate('mod')">
      <i class="mdi mdi-account-circle d-md-none d-block"></i>
      <span class="d-none d-md-block">{{ 'channel.view.tabModules' | translate }}</span>
    </a>
  </li>
  }
  <li class="nav-item">
    <a class="nav-link" id="dep-tab" data-bs-toggle="tab" data-bs-target="#dep" type="button" role="tab"
      aria-controls="dep" aria-selected="true" (click)="activate('dep')">
      <i class="mdi mdi-account-circle d-md-none d-block"></i>
      <span class="d-none d-md-block">{{ 'channel.view.tabDepartments' | translate }}</span>
    </a>
  </li>
  @if (channel?.type !== 'WEBCHAT_API') {
  <li class="nav-item">
    <a class="nav-link" id="webhook-tab" data-bs-toggle="tab" data-bs-target="#webhook" type="button" role="tab"
      aria-controls="webhook" aria-selected="true" (click)="activate('webhook')">
      <i class="mdi mdi-account-circle d-md-none d-block"></i>
      <span class="d-none d-md-block">{{ 'channel.view.tabOutboundWebhooks' | translate }}</span>
    </a>
  </li>
  }
  @if (getModuleCopilot() && channel?.type !== 'WEBCHAT_API') {
  <li class="nav-item">
    <a class="nav-link" id="copilot-tab" data-bs-toggle="tab" data-bs-target="#copilot" type="button" role="tab"
      aria-controls="copilot" aria-selected="false" (click)="activate('copilot')">
      <i class="ri-robot-2-line d-md-none d-block"></i>
      <span class="d-none d-md-block">Copilot <span class="badge text-bg-warning ms-1">Beta</span></span>
    </a>
  </li>
  }
  @if (getModuleAPI() && channel?.type !== 'WEBCHAT_API') {
  <li class="nav-item">
    <a class="nav-link" id="api-tab" data-bs-toggle="tab" data-bs-target="#api" type="button" role="tab"
      aria-controls="api" aria-selected="true" (click)="activate('api')">
      <i class="mdi mdi-account-circle d-md-none d-block"></i>
      <span class="d-none d-md-block">API</span>
    </a>
  </li>
  }
  }
</ul>

<div class="tab-content" id="tabComponentsContent">
  <div class="tab-pane fade show active" id="dash" role="tabpanel" aria-labelledby="dash-tab"
    [class.active]="activeTab === 'dash'" [class.show]="activeTab === 'dash'">
    @if(activeTab === 'dash') {
    <!-- Cloud API: the dashboard is the health shell with its four sub-areas
         (SPEC-2026-08-channel-health, RF-15/RF-16); other types keep today's screen. -->
    @if (channel?.type === 'CLOUD_API' && (isAdmin() || isSupervisor())) {
    <channel-health-dashboard [channel]="channel" />
    } @else {
    <channel-config-component [channel]="channel" />
    }
    }
  </div>

  <!-- Mirrors the nav-tabs guard above: both must list the same types or the tabs render with empty panes. -->
  @if (channel?.type !== 'VOIP_API') {
  @if (channel?.type !== 'WEBCHAT_API') {
  <div class="tab-pane fade" id="config" role="tabpanel" aria-labelledby="config-tab"
    [class.active]="activeTab === 'config'" [class.show]="activeTab === 'config'">
    @if(activeTab === 'config') {
    <settings-attendance-component [channel]="channel" />
    }
  </div>
  }

  <div class="tab-pane fade" id="auto" role="tabpanel" aria-labelledby="auto-tab" [class.active]="activeTab === 'auto'"
    [class.show]="activeTab === 'auto'">
    @if(activeTab === 'auto') {
    <chatbot-component [channel]="channel" />
    }
  </div>

  <div class="tab-pane fade" id="response" role="tabpanel" aria-labelledby="response-tab"
    [class.active]="activeTab === 'response'" [class.show]="activeTab === 'response'">
    @if(activeTab === 'response') {
    <response-automatic-component [channel]="channel" />
    }
  </div>

  @if (channel?.type === 'CLOUD_API') {
  <div class="tab-pane fade" id="template" role="tabpanel" aria-labelledby="template-tab"
    [class.active]="activeTab === 'template'" [class.show]="activeTab === 'template'">
    @if(activeTab === 'template') {
    <settings-template-list-component [channel]="channel" />
    }
  </div>
  }

  @if (channel?.type !== 'WEBCHAT_API') {
  <div class="tab-pane fade" id="mod" role="tabpanel" aria-labelledby="mod-tab" [class.active]="activeTab === 'mod'"
    [class.show]="activeTab === 'mod'">
    @if(activeTab === 'mod') {
    <settings-module-component [channel]="channel" />
    }
  </div>
  }

  <div class="tab-pane fade" id="dep" role="tabpanel" aria-labelledby="dep-tab" [class.active]="activeTab === 'dep'"
    [class.show]="activeTab === 'dep'">
    @if(activeTab === 'dep') {
    <department-component [channel]="channel" />
    }
  </div>

  @if (channel?.type !== 'WEBCHAT_API') {
  <div class="tab-pane fade" id="webhook" role="tabpanel" aria-labelledby="webhook-tab"
    [class.active]="activeTab === 'webhook'" [class.show]="activeTab === 'webhook'">
    @if(activeTab === 'webhook') {
    <settings-webhook-component [channel]="channel" />
    }
  </div>
  }

  @if (getModuleCopilot() && channel?.type !== 'WEBCHAT_API') {
  <div class="tab-pane fade" id="copilot" role="tabpanel" aria-labelledby="copilot-tab"
    [class.active]="activeTab === 'copilot'" [class.show]="activeTab === 'copilot'">
    @if(activeTab === 'copilot') {
    <channel-config-copilot [channel]="channel"></channel-config-copilot>
    }
  </div>
  }

  @if (channel?.type !== 'WEBCHAT_API') {
  <div class="tab-pane fade" id="api" role="tabpanel" aria-labelledby="api-tab" [class.active]="activeTab === 'api'"
    [class.show]="activeTab === 'api'">
    @if(activeTab === 'api') {
    <channel-apis-component [channel]="channel"></channel-apis-component>
    }
  </div>
  }
  }
</div>
}